import { ApplicationVersion } from '@kw/device-service/dist/application/entities/applicationVersion.entity';
import { PolicyDetails } from '@kw/service-definitions-eval';
import { createQueryString } from '../../../utils/createQueryString';
import { useFetchService } from '../../../utils/fetchService';
import { useStickyResult } from '../../../utils/useStickyResult';

const sleep = (ms: number) =>
  new Promise<void>(resolve => {
    setTimeout(resolve, ms);
  });

export const useAppVersions = (endpoint, appParams, accessToken) => {
  const queryParams = createQueryString(appParams);

  const path = `${endpoint}?${queryParams}`;

  const {
    data: appData,
    error: appsDataError,
    mutate,
  } = useFetchService<{
    apps: ApplicationVersion[];
    policies: PolicyDetails[];
    totalApps: number;
    totalDevices: number;
    totalManagedApps: number;
    totalDiscoveredApps: number;
  }>(path, accessToken, true);
  const { apps, policies, totalApps = 0, totalDevices, totalManagedApps, totalDiscoveredApps } = useStickyResult(appData);
  const isLoading = !appData && !appsDataError;

  const mutateWithDelay = async (ms = 1500) => {
    await sleep(ms);
    return mutate(); // revalidate now
  };

  return {
    apps,
    policies,
    totalApps,
    totalDevices,
    totalManagedApps,
    totalDiscoveredApps,
    appsDataError,
    isLoading,
    mutate,
    mutateWithDelay,
  };
};

export const useHighRiskCountries = (accessToken: string) => {
  const { data, error: highRiskCountriesError } = useFetchService<{ highRiskCountries: string[]; total: number }>(
    '/list/high-risk-countries',
    accessToken,
  );
  const { highRiskCountries, total: highRiskCountriesTotal } = useStickyResult(data);

  return { highRiskCountries, highRiskCountriesTotal, highRiskCountriesError };
};

export const useCategories = (accessToken: string) => {
  const { data, error: categoriesError } = useFetchService<{ categories: string[] }>('/application/categories', accessToken);
  const { categories } = useStickyResult(data);

  return { categories, categoriesError };
};

export const useVendorNames = (accessToken: string) => {
  const { data, error: vendorNamesError } = useFetchService<{ vendorNames: string[] }>(
    '/eval/applications/developer-name-list',
    accessToken,
  );

  const vendorNames = data?.map((item: { developer_name: string }) => item.developer_name) || [];

  return { vendorNames, vendorNamesError };
};
